module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAwCAYAAABuZUjcAAABIElEQVRoge2YMQrCQBBFv2ElkYgpFUQbOxEv4A1s9BSewGMIdp5DG0+gV/AAGkuLQJAEgtqoVTSDLqMD82CrHf6+YrI7pBSGmAPoQRYnA6ByX5LwHQCXX1t8wMX5tcGnqDg3Ks6NWHFjPdAMXWO6Xt5ekswia+fYCnrg+5N6tTpq5e0dj7OtrXPEtoqKc6Pi3Kg4N2LFyQ+Q500DUqBpuN9mZNkuybJ1+q6mFIZYAOgXhTWb1wHlUBvE8eoQReP9m5KT2FZRcW7EipNvlTheHSh1rturlcud3NuDmpGmm8K5nSxe8JU/CYJl+5U4NYOC2FZRcW5UnBsV50asuPUfQpRXzwbkefzP0HmcHRXnRsW5UXFuRItLlHcMgOS+JHG+ATmwPtm0ov7TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/mas.png
// module id = 788
// module chunks = 0